import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../models/utilities/list-header";
import { PageData } from "../../models/utilities/paged-request";
import { ApiEndpoints, GlobalConstants } from "../../utils/app-constants";

export class SupportActivitySearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.SUPPORT_ACTIVITY_FEED;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('ID', ''),
            new ListColumn('Event ID', ''),
            // new ListColumn('Type', ''),
            new ListColumn('Type Name', ''),
            new ListColumn('Correlation ID', ''),
            new ListColumn('Causation ID', ''),
            new ListColumn('User ID', ''),
            new ListColumn('Entity ID', ''),
            new ListColumn('Created', '')
        ];

        // Create our Filter Groups
        const byCorrelation = this.buildCorrelationId();
        const byCausationId = this.buildUserId();
        const byEntity      = this.buildEntity();
        
        this.filters.push(
            byEntity, byCorrelation, byCausationId
        );

    }

    // #region Group Builders

    private buildCorrelationId() {
        const byCorrelationId = new FilterGroup('Correlation ID', 'text', 'correlationId');
        const opt1 = new FilterBarInputOpt('Correlation ID', '');
        
        byCorrelationId.opts = [opt1];

        return byCorrelationId;
    }

    private buildUserId() {
        const byUserId = new FilterGroup('User ID', 'text', 'userId');
        const opt1 = new FilterBarInputOpt('User ID', '');
        
        byUserId.opts = [opt1];

        return byUserId;
    }

    private buildEntity() {
        const buildEntity = new FilterGroup('Entity', 'text', 'entity');
        const opt1 = new FilterBarInputOpt('Entity', '');
        
        buildEntity.opts = [opt1];

        return buildEntity;
    }
    
    // #endregion

}
